import { Container, Divider, Grid, Segment } from "semantic-ui-react";
import Ikon1 from "../images/Ikon1.png";
import Ikon2 from "../images/Ikon2.png";
import Ikon3 from "../images/Ikon3.png";
import IkonInvesteringsunivers from "../images/IkonInvesteringsunivers.svg";
import IkonForvaltning from "../images/IkonForvaltning.svg";
import IkonRisikostyring from "../images/IkonRisikostyring.svg";
import IkonGroenOmstilling from "../images/IkonGroenOmstilling.svg";
import IkonIngenAlternativeInvesteringer from "../images/IkonIngenAlternativeInvesteringer.svg";
import "./Selvstaendige.css";

const IndeksPlus = (props) => (
  <div style={{ backgroundColor: "white" }}>
    <Container text>
      <Segment basic>
        <p>1. oktober 2026</p>
        <h2 className="trompet">INVESTERINGSFOKUS</h2>
        <h2 className="ui header" style={{ paddingTop: 0 }}>
          PFA Klima Plus
        </h2>
      </Segment>
    </Container>

    <Container text>
      <Segment basic>
        <p className="manchet">
          Med PFA Klima Plus kan du placere hele eller en del af din
          pensionsopsparing i investeringer, som er med til at fremme den grønne
          omstilling gennem fokus på et lavt CO<sub>2</sub>-aftryk, investering
          i aktiver, der understøtter grøn omstilling, samt aktivt ejerskab.
        </p>

        <h3>PFA Klima Plus er til dig, der:</h3>
        <ul>
          <li>
            Ønsker at din opsparing bidrager til den grønne omstilling gennem
            blandt andet øgede CO<sub>2</sub>-ambitioner og eksklusion af våben
            samt olie- og gasselskaber.
          </li>
          <li>
            Kan acceptere et lidt lavere langsigtet forventet afkast som følge
            af et mere begrænset investeringsunivers.
          </li>
          <li>
            Ønsker at eksperter overvåger og løbende justerer din opsparing med
            henblik på at optimere forholdet mellem risiko og afkastpotentiale.
          </li>
        </ul>

        <h3>PFA Klima Plus og ansvarlige investeringer</h3>
        <p>
          Investeringerne i PFA Klima Plus bliver ligesom PFA’s øvrige
          investeringer vurderet ud fra de krav, vi har opstillet i vores
          Politik for ansvarlige investeringer og aktivt ejerskab. Herudover
          investerer du din pensionsopsparing med udgangspunkt i tre klimakrav:
        </p>
        <Divider hidden />

        <Grid centered stackable columns={2}>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${Ikon1})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>
                Skærpet CO<sub>2</sub>-fokus
              </h4>
              <p>
                Aktieporteføljen i PFA Klima Plus skal udlede 60 % mindre CO
                <sub>2</sub>
                end verdensaktieindekset målt på den fulde værdikæde.
                <sup>1</sup>
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${Ikon2})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Eksklusion af den fossile sektor</h4>
              <p>
                Olie-, kul- og gasselskaber samt selskaber med stor tilknytning
                til den fossile sektor ekskluderes.<sup>2</sup>
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${Ikon3})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>
                CO<sub>2</sub>-neutralitet og negativ
              </h4>
              <p>
                PFA Klima Plus har siden udgangen af 2025 været CO<sub>2</sub>
                -neutral målt på scope 1 og 2, og det er ambitionen at være CO
                <sub>2</sub>-negativ inden udgangen af 2030.<sup>3</sup>
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <p>
          PFA Klima Plus ekskluderer derudover våben målt efter MSCI's Global
          Industry Classification Standard (GICS) sub-industrien Aerospace &
          Defense. Investeringerne bliver foretaget med udgangspunkt i PFA’s
          Politik for ansvarlige investeringer og aktivt ejerskab, som skal
          sikre, at PFA fremmer overholdelse af internationale normer indenfor
          blandt andet menneskerettigheder, arbejdstagerrettigheder, miljø og
          anti-korruption.
        </p>
        <p>
          Bemærk, at investeringer, der understøtter et lavt CO<sub>2</sub>
          -aftryk, ikke nødvendigvis er bæredygtige i sig selv.
        </p>
        <p>
          <i>
            <sup>1</sup>MSCI All Countries World Index, CO<sub>2</sub> måles på
            scope 1, scope 2 og scope 3.
          </i>
        </p>
        <p>
          <i>
            {" "}
            <sup>2</sup>For børsnoterede aktier ved at følge
            eksklusionskriterierne for EU Paris-Aligned Benchmark (PAB), samt
            fra kriterier angivet i GICS Energy Sector. Defineret ved Artikel 12
            ”Udelukkelser for Paris tilpassede EU-benchmarks”, KOMMISSIONENS
            DELEGEREDE FORORDNING (EU) 2020/1818 af 17. juli 2020.
          </i>
        </p>
        <p>
          <i>
            {" "}
            <sup>3</sup>CO<sub>2</sub>-neutralitet og -negativitet søges opfyldt
            gennem investering i skov og teknologi, der tager CO<sub>2</sub> ud
            ad atmosfæren. Med CO<sub>2</sub>-negativ forstås, at de
            underliggende investeringer trækker mere CO<sub>2</sub> ud ad
            atmosfæren, end investeringerne selv udleder.
          </i>
        </p>
      </Segment>

      <Divider hidden />

      <Segment basic style={{ backgroundColor: "#f6f0e7" }}>
        <h3 style={{ color: "#e49d3b" }}>Skærpet fokus på klima</h3>
        <p>
          Med PFA Klima Plus bliver din opsparing investeret med fokus på at
          fremme den grønne omstilling blandt andet gennem investeringer, som
          bidrager til et lavt CO<sub>2</sub>-aftryk, investeringer i aktiver,
          som understøtter grøn omstilling, samt aktivt ejerskab.
          Investeringerne tager udgangspunkt i hele PFA’s investeringsunivers,
          hvilket betyder, at der investeres i fx aktier, obligationer og
          alternative investeringer. For at sikre bidraget til at fremme den
          grønne omstilling samtidig med at opnå det bedst mulige
          afkastpotentiale er der skærpede klimakriterier til de aktiver, din
          opsparing i PFA Klima Plus kan investeres i.
        </p>
        <p>
          Et selskab i aktieporteføljen kan indgå i PFA Klima Plus, hvis et af
          disse kriterier er opfyldt:
        </p>
        <ul>
          <li>
            Den del af selskabets omsætning, som er i overensstemmelse med
            EU-klassificeringssystemet (taksonomien), udgør 15 procent eller
            mere.
          </li>
          <li>
            Selskabet er enten forpligtet til Science-based Targets initiative
            (SBTi) eller har SBTi-godkendte klimamål.
          </li>
          <li>
            Selskabet har en impliceret temperaturstigning (ITR) på under 2
            grader.
          </li>
        </ul>
        <p>
          For obligationsporteføljen gælder, at der som udgangspunkt investeres
          i grønne børsnoterede stats- og virksomhedsobligationer, hvis
          udstedelse er baseret på The International Capital Market Group
          (ICMA)’s principper for grønne obligationer. Der vil også blive
          investeret i almindelige realkreditobligationer.{" "}
        </p>
        <p>
          I størstedelen af ejendomsporteføljen foretages der investeringer i
          ejendomme, der enten er energiefficiente (Energimærke A) i
          overensstemmelse med EU-klassificeringssystemet (Taksonomien) eller
          har DGNB platin- eller guldcertificering (eller tilsvarende).{" "}
        </p>
        <p>
          Alternative investeringer i form af private equity, infrastruktur og
          unoteret kredit sker med ønsket om at bidrage til den grønne
          omstilling (hvor muligt i tråd med krav til tilsvarende børsnoterede
          aktiver). Derudover er der fokus på investeringer i naturressourcer
          med CO<sub>2</sub>-absorberende egenskaber, som skal være med til at
          realisere ambitionen om at gøre de samlede investeringer fra PFA Klima
          Plus CO<sub>2</sub>-negative i 2030.{" "}
        </p>
        <p>
          Da investeringsuniverset er mere begrænset, forventer vi, at afkastet
          over et livsforløb kan blive lavere end i PFA Plus, men i praksis kan
          afkastet dog både være højere, det samme eller lavere.
        </p>
      </Segment>
      <Divider hidden />

      <Segment basic>
        <h3>Fordele ved PFA Klima Plus</h3>
        <Divider hidden />

        <Grid centered stackable columns={2}>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonInvesteringsunivers})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>Bredt investeringsunivers,</b> hvor din opsparing investeres
                i mange forskellige typer af aktiver – fra aktier og
                obligationer til ejendomme, private equity og infrastruktur,
                skov mv. Det giver både spredning af risiko og mulighed for et
                højere afkast.{" "}
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonForvaltning})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>Aktiv forvaltning,</b> hvor vi tror på, at vi kan skabe
                værdi. Dette er bl.a. danske aktier og obligationer fordi
                markedskendskab og nærhed gør en forskel.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonRisikostyring})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>Risikostyring</b> gør at PFA’s investeringseksperter løbende
                kan tilpasse investeringerne til den aktuelle verdenssituation
                f.eks. ved at sikre beskyttelse, når der er store stød i
                økonomien.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonGroenOmstilling})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>Ekstra fokus på grøn omstilling</b> for at bidrage til at
                fremme den grønne omstilling er der skærpede klimakriterier til
                investeringerne i din opsparing. Der er desuden et skærpet CO
                <sub>2</sub>-fokus, øget eksklusioner og en ambition om at være
                CO<sub>2</sub>-negativ i 2030.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{
                  backgroundImage: `url(${IkonIngenAlternativeInvesteringer})`,
                }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>
                  Fravalg af investeringer i olie og gasselskaber samt
                  våbenproducenter.
                </b>
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <h3>
          CO<sub>2</sub>-fokus på tværs af værdikæden i PFA Klima Plus
        </h3>
        <p>
          Aktieporteføljen i PFA Klima Plus skal udlede minimum 60 procent
          mindre CO<sub>2</sub> end verdensaktieindekset, MSCI ACWI. Der måles
          på scope 1, 2 og 3.
        </p>
        <p>
          Scope 1 måler den direkte CO<sub>2</sub>-udledning fra virksomheden
          selv, mens scope 2 måler den CO<sub>2</sub>-udledning, som
          virksomheden indirekte er skyld i, eksempelvis CO<sub>2</sub>
          -udledning fra energi produceret til virksomheden. Scope 3 måler den
          CO<sub>2</sub>, som virksomhedens andre indirekte opstrøms- og
          nedstrømsaktiviteter udleder, dvs. aktiviteter virksomheden ikke ejer,
          kontrollerer eller kan styre. Det kan f.eks. være anvendelsen af
          virksomhedens produkter og indkøb af materiale til produktion af
          virksomhedens produkter.{" "}
        </p>
      </Segment>
      <Divider hidden />
      <Segment basic style={{ backgroundColor: "#f6f0e7" }}>
        <h3 style={{ color: "#e49d3b" }}>
          Vi måler løbende CO<sub>2</sub>-udledningen på vores porteføljer og
          sammenligner med verdensindekset
        </h3>
        <p>
          I PFA Klima Plus udleder aktierne 76 % mindre CO<sub>2</sub> end
          verdensaktieindekset, mens investeringerne i PFA Plus på tidspunktet
          for målingerne udledte 39 % mindre CO<sub>2</sub>.
        </p>
      </Segment>
    </Container>
  </div>
);

export default IndeksPlus;
